// extracted by mini-css-extract-plugin
export default {"Box":"chart-link-module__Box--NKq1V","PotentiallyDirty":"chart-link-module__PotentiallyDirty--pws1C"};